class DevHelpers {
	constructor() {
		devMode = localStorage.getItem('devMode');

		if (devMode === 'true') {
			document.body.classList.add('debug-mode');
			document.querySelector("body").insertAdjacentHTML("beforeend", `<div class="debug-viewport-info">debug on</div>`);
			this.debugDiv = document.querySelector(".debug-viewport-info");
			this.viewportSizeHelper();
			resizeCallbacks.push(this);
		}
	}

	viewportSizeHelper() {
		const viewportWidth = window.innerWidth;
		const viewportHeight = window.innerHeight;
		this.debugDiv.innerHTML = `${viewportWidth}px &times; ${viewportHeight}px`;
	}

	resize() {
		this.viewportSizeHelper();
	}
}